
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"16","viewBox":"0 0 12 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.249 15.889a.334.334 0 01-.498 0C1.922 11.609 0 8.33 0 6c0-3.517 2.483-6 6-6s6 2.483 6 6c0 2.33-1.922 5.61-5.751 9.889zM11.333 6C11.333 2.85 9.15.667 6 .667 2.85.667.667 2.85.667 6c0 2.067 1.773 5.138 5.333 9.165C9.56 11.14 11.333 8.067 11.333 6zM6 8.667a2.667 2.667 0 110-5.334 2.667 2.667 0 010 5.334zM6 8a2 2 0 100-4 2 2 0 000 4z","fill":"#50657c"}})])
          )
        }
      }
    